/* Connector marks for Curation's activation pages (FEATURES.curationSkin): the brand library's square for each MAP
   connector type, in place of MAP's own mixed set of icons; MAP's icon stays when the skin is off. */
import { SQUARES, CHANNEL_BRAND, WIDE_BRANDS } from "./channelSquares";
import { CHANNEL_FULLS } from "./channelFulls";
import { FEATURES } from "./features";

export const chMark = (type: string, fallback: string): string => {
  const b = CHANNEL_BRAND[(type || "").toLowerCase()];
  if (!FEATURES.curationSkin) return fallback;
  // a wordmark brand (WIDE_BRANDS) gives its full mark, flagged "#wide" so the skin sizes it as a wide tile of the
  // squares' height (curation-ui.css, "connector marks"); the fragment does not change the image
  if (WIDE_BRANDS.includes(b) && CHANNEL_FULLS[b]) return CHANNEL_FULLS[b] + "#wide";
  return SQUARES[b] || fallback;
};
